import { useCreateQuery, QueryOptions } from '../../CRUD';
import { axiosService } from '../../services/axiosService';
import { IntegratorConfiguration } from './types';
import { integratorBaseModel } from './crud';

const getEhrIntegratorsConfiguration = () =>
  axiosService
    .get<IntegratorConfiguration[]>('/integrators/configuration')
    .then((res) => res.data);

export const fetchEhrIntegratorsConfiguration =
  () => (options?: QueryOptions<IntegratorConfiguration[]>) =>
    useCreateQuery<IntegratorConfiguration[]>(
      [...integratorBaseModel.keys.all, 'configuration'],
      getEhrIntegratorsConfiguration,
      options,
    );
